import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import ComunicadoCategoriaForm from './ComunicadoCategoriaForm';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import ComunicadoCategoriaTable from "./ComunicadoCategoriaTable";
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const useStyles = makeStyles({
    paper: {

        padding: '20px',
        backgroundColor: '#f5f5f5',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    voltarButton: {
        marginBottom: '20px',
    }
});

export default function ComunicadoCategoriaContainer() {
    const classes = useStyles();
    const comunicadoCategoria = useSelector(state => state.comunicadoCategoria);


    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>

                <Button
                    component={Link} to="/comunicado"
                    variant="contained"
                    color="secondary"
                    className={classes.voltarButton}>
                    <ArrowBackIcon style={{ marginRight: '10px' }} />
                    Voltar
                </Button>
                <Grid container justify="space-between">
                    <Grid size={3}>
                        <Typography className={classes.title} variant="h5">
                            Categorias
                        </Typography>
                    </Grid>
                </Grid>


                {comunicadoCategoria ?
                    <Grid style={{ marginBottom: '20px' }} container>
                        <ComunicadoCategoriaForm />
                    </Grid>
                    : ''}

                <Grid >
                    <ComunicadoCategoriaTable />
                </Grid>
            </Container>
        </div>
    );
}